const subNavBodyLock = document.getElementById('MainBodyContent');
class SubNavigation extends HTMLElement {
    constructor() {
        super();
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        window.addEventListener("scroll", this.subNavScrollTo.bind(this));
        window.addEventListener("resize", this.subNavResize.bind(this));
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
        this.mobileSubNavMenuButton = document.querySelectorAll('li.main-mobile-slide');
        this.mobileSubNavChildMenuButton = document.querySelectorAll('li.child-mobile-slide');
        this.mobileSubNavDropMenuButton = document.querySelectorAll('li.main-mobile-dropdown');
        this.mobileSubNavDropChildMenuButton = document.querySelectorAll('li.child-mobile-dropdown');
        this.subNavBlock = document.querySelectorAll('li.child-block');
        this.mobileSubNavMenuClose = document.querySelectorAll('.sub-nav-link-header');
        this.subNavButton = this.querySelector('.sub-navigation-btn');
        this.subNavDropdown = this.querySelector('.sub-navigation-menu');
        this.subNavTop = this.offsetTop;
        this.subNavHeight = this.offsetHeight;
        this.subNavMobileDropdown();
        this.subNavMobileSlide();
    } 

    connectedCallback() {
        if (this.windowWidth < 768) {
            document.documentElement.style.setProperty('--viewport-sub-height', `${this.windowHeight}px`);
            document.documentElement.style.setProperty('--viewport-sub-offset', `${this.subNavTop + this.subNavHeight}px`);
        }
        /*
        this.subNavBlock.forEach(element => {
            const subNavNext = element.nextElementSibling;
            if (subNavNext && subNavNext.tagName === 'LI'){
                subNavNext.remove();
            }
        });
        */
    }

    onButtonClick(event) {
        event.preventDefault();
        this.mobileSubNavMenuButton.forEach((element) => {
            element.classList.remove('active');
        });
        this.mobileSubNavChildMenuButton.forEach((element) => {
            element.classList.remove('active');
        });
        this.subNavButton.classList.toggle('open');
        //subNavBodyLock.classList.toggle('overflow-hidden-tablet');
        this.subNavDropdown.classList.toggle('active');
    }

    subNavScrollTo() {
        const mainContentTopPadding = document.querySelector('.content-for-layout');
        if(this.hasAttribute('data-stick-always')) {
            if (window.scrollY >= this.subNavTop) {
                this.classList.add('sticky');
                mainContentTopPadding.style.paddingTop = `${this.subNavHeight}px`;
            } else {
                this.classList.remove('sticky');
                mainContentTopPadding.removeAttribute('style');
            }
        }
    }

    subNavMobileDropdown() {
        this.mobileSubNavDropMenuButton.forEach(element => {
            element.addEventListener('click', function() {
                this.classList.toggle('active');
            });
        });
         this.mobileSubNavDropChildMenuButton.forEach(element => {
            element.addEventListener('click', function() {
                event.stopPropagation();
                this.classList.toggle('active');
            });
        });
    }

    subNavMobileSlide() {
        this.mobileSubNavMenuButton.forEach(element => {
            element.addEventListener('click', function() {
                this.classList.add('active');
            });
        });
         this.mobileSubNavChildMenuButton.forEach(element => {
            element.addEventListener('click', function() {
                this.classList.add('active');
            });
        });
        this.mobileSubNavMenuClose.forEach(element => {
            element.addEventListener('click', function(event) {
                event.stopPropagation();
                this.parentNode.parentNode.classList.remove('active');
            });
        });
    }

    subNavResize() {
        const subNavRemove = document.querySelectorAll('.sub-navigation-btn, .sub-navigation-menu, li.parent-link.dropdown');
        if (window.innerWidth >= 768) {
            //subNavBodyLock.classList.remove('overflow-hidden-tablet');
            subNavRemove.forEach(element => {
                element.classList.remove('active');
                element.classList.remove('open');
            });
        } else {
            document.documentElement.style.setProperty('--viewport-sub-height', `${this.windowHeight}px`);
            document.documentElement.style.setProperty('--viewport-sub-offset', `${this.subNavTop + this.subNavHeight}px`);
        }
    }
}

customElements.define('sub-navigation', SubNavigation);